import React from 'react'
import { INode } from 'shared/types/tree'
import { Box, Button } from '@mui/material'
import { directTreeAccessUrl } from 'infrastructure/api'
import { copyToClipboard } from 'shared/utils'

export function TreeUrlView({ tree }: { tree?: INode | null }) {
  if (!tree) return null

  const treeLink = directTreeAccessUrl({
    treeId: tree.tree_id,
    versionId: tree.version,
  })
  return (
    <Box display="flex" flexDirection="row" alignItems="center">
      {treeLink}
      <Button onClick={() => copyToClipboard(treeLink)}>Copy</Button>
    </Box>
  )
}
